import React from "react";
import clsx from "clsx";

import { WarningMessages } from "globalConstants";

import styles from "./../splitProfile.module.scss";

export const WaterfallWarningMessage = () => {
	const { WaterfallSplit100PercentWarningMessage } = WarningMessages;
	return (
		<div className={clsx(styles.externalContent)}>
			<span className="text-warning fs-5">
				{WaterfallSplit100PercentWarningMessage}
			</span>
		</div>
	);
};
